<template>
	<div class="overlay-dialog">
		<h2
			class="overlay-dialog__title"
			v-html="title"
		/>
		<div
			class="overlay-dialog__text"
			v-html="message"
		/>

		<CartChanges
			:text="$t('cart.timeEdit.cartChange.changeTitleAutomatic')"
			:changes="changedItemsEnhanced"
		/>
		<div class="overlay-dialog__buttons">
			<Button
				@click.prevent="$emit('confirm')"
				level="primary"
				type="button"
				text="OK"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Button from '@/components/Button'
import CartChanges from '@/components/CartChanges';

export default {
	mixins: [

		],
	components: {
		Button,
		CartChanges,
	},
	props: {
		title: {
			default() {
				return this.$t('cart.timeEdit.cartChange.title')
			},
		},
		message: {
			default: '',
		},
		changedItems: {
			type: Array,
			default: [],
		},
	},
	data() {
		return {
		}
	},
	computed: {
		changedItemsEnhanced() {
			return this.changedItems.map(item => {
				return {
					...item,
					image: item.image.length && item.image[0].path || "",
				}
			});
		}
	},
	methods: {
	}
}
</script>

<style>

</style>